// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"787":"3f3ca855","829":"86cc38c1"}[chunkId] + ".chunk.css";
};